import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { HeightInput, NumberInput } from '../../../../Inputs';
import React from 'react';

const useStyles = makeStyles()({
  weightInput: {
    width: '100px',
  }
});


export const HeightAndWeightForm: React.VFC = () => {
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="column" gap="16px">
      <Box>
        <NumberInput
          name="weight"
          label="Weight"
          color="secondary"
          inputClasses={{ root: classes.weightInput }}
          helperText="Required for clients under 18 years old"
          InputProps={{ endAdornment: 'lbs' }}
          numberInputProps={{
            decimalScale: 0,
            isAllowed: (values) => {
              if (values.floatValue === undefined) {
                return true;
              }
              if (typeof values.floatValue === 'number') {
                return values.floatValue < 1000;
              }

              return false;
            }
          }}
        />
      </Box>

      <Box width="150px">
        <HeightInput name="height" color="secondary" label="Height (optional)" />
      </Box>
    </Box>
  );
};
